import React, { useRef } from 'react';
import { CenteredContentLayout } from '../../../components/containers/CenteredContentLayout';
import { Panel } from '../../../components/containers/Panel';
import { Button } from '../../../components/actions/Button';
import { ButtonColorsEnum } from '../../../constants/button-colors';
import { IconsEnum } from '../../../constants/icons';
import { useNavigate } from 'react-router-dom';
import classes from './Invoice.module.scss';
import { InvoiceDetailView } from './InvoiceDetail.view';
import { Invoice } from '../../../models/graphql';
import { handleDownloadPDF } from '../../../helpers/billingHelpers';
import { useDimensions } from '../../../hooks/useDimensions';
import classNames from 'classnames';

export type InvoiceViewProps = {
  loading: boolean;
  invoice: Invoice | undefined;
};

export enum PDFSizeEnum {
  'A4' = 'A4',
  'LETTER' = 'LETTER'
}

export const InvoiceView = ({ invoice, loading }: InvoiceViewProps): JSX.Element => {
  const documentRef = useRef<HTMLElement>(document.body);
  const { width } = useDimensions(documentRef);
  const navigate = useNavigate();
  const invoiceRef = useRef<HTMLDivElement | null>(null);

  if (!invoice) {
    return <></>;
  }

  const printableInvoiceClasses = classNames(classes.Invoice, classes.PrintableInvoice);

  return (
    <CenteredContentLayout headerTitle={''} loading={loading} hasSidebar={false}>
      <div>
        <div className={'padding-top-small-16 padding-bottom-small-32'}>
          <div className={'grid-x grid-padding-x align-justify'}>
            <Button
              type={'button'}
              variant={'hollow'}
              size={'medium'}
              color={ButtonColorsEnum.primary}
              icon={{ side: 'left', value: IconsEnum.arrowLeft }}
              action={() => navigate('/settings/billings')}>
              Back {width > 375 && <>to Invoices</>}
            </Button>

            <Button
              type={'button'}
              variant={'solid'}
              size={'medium'}
              color={ButtonColorsEnum.primary}
              icon={{ side: 'left', value: IconsEnum.download }}
              action={() => {
                if (invoice && invoice.id != null) {
                  // @TODO: Handle toast?
                  handleDownloadPDF(invoiceRef, invoice.id).finally();
                }
              }}>
              Download PDF
            </Button>
          </div>
        </div>

        <Panel customClass={classes.Invoice}>
          <InvoiceDetailView invoice={invoice} />
        </Panel>
      </div>
      <div ref={invoiceRef} className={classes.InvoicePanelWrapper}>
        <Panel customClass={printableInvoiceClasses}>
          <InvoiceDetailView invoice={invoice} />
        </Panel>
      </div>
    </CenteredContentLayout>
  );
};
